import { Cookies } from 'react-cookie';

import { EndVisitTimerFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface EndTimerInterface {
  endVisitData: EndVisitTimerFormValues;
  id: string;
  slug: string;
}

export const endVisitTimerFetch = async ({ endVisitData, id, slug }: EndTimerInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/visit_report/${slug}/${id}/end-timer/`,
    {
      ...endVisitData,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
